import type { ReactNode } from 'react';
import clsx from 'clsx';

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center rounded-panel border-2 border-dashed border-border px-6 py-14 text-center',
        className,
      )}
    >
      {icon && (
        <div className="mb-4 grid size-14 place-items-center rounded-panel bg-primary-subtle text-primary ring-8 ring-primary-subtle/50">
          {icon}
        </div>
      )}
      <h3 className="text-base font-semibold text-fg">{title}</h3>
      {description && <p className="mt-1.5 max-w-sm text-sm text-fg-secondary">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
